import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * Native `<select>` styled to match the shadcn input/button vocabulary.
 *
 * The full Radix Select primitive is overkill for the registry filters used in
 * Story 2.3 (single-value pickers + a CSV-backed multiselect built on
 * checkboxes). Keeping this lean avoids pulling another dep into the bundle.
 */
export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <select
        ref={ref}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </select>
    )
  },
)
Select.displayName = 'Select'
